module.exports = __webpack_public_path__ + "img/3_104.4e8a9e2b.png";